import { Alert as ChakraAlert } from "@chakra-ui/react";
import * as React from "react";

export interface AlertProps extends Omit<ChakraAlert.RootProps, "title"> {
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  title?: React.ReactNode;
  icon?: React.ReactElement;
  fontSize?: string;
  [key: string]: any;
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    const {
      title,
      children,
      icon,
      startElement,
      endElement,
      fontSize,
      ...rest
    } = props;
    return (
      <ChakraAlert.Root
        bg={"transparent"}
        p={1}
        ref={ref}
        alignItems="center"
        alignSelf="center"
        justifyContent="center"
        gap={2}
        {...rest}
      >
        <ChakraAlert.Indicator
          fontSize={fontSize}
          alignItems="center"
          justifyContent="center"
        >
          {startElement || icon}
        </ChakraAlert.Indicator>
        {children ? (
          <ChakraAlert.Content
            alignItems="center"
            justifyContent="center"
            maxWidth="fit-content"
          >
            {title && <ChakraAlert.Title>{title}</ChakraAlert.Title>}
            <ChakraAlert.Description fontSize={fontSize}>
              {children}
            </ChakraAlert.Description>
          </ChakraAlert.Content>
        ) : (
          <ChakraAlert.Title>{title}</ChakraAlert.Title>
        )}
        {endElement}
      </ChakraAlert.Root>
    );
  }
);
